import { api } from "@/utils/api";
import { FormEvent, useState, useRef, useEffect } from "react";
import { toast } from "@/utils/appToast";

type PhoneVerificationFormProps = {
  phone: string;
  onHide: () => void;
  onVerificationSuccess: (phoneCode:string) => void;
};

export const PhoneVerificationForm = ({ phone, onHide, onVerificationSuccess }: PhoneVerificationFormProps) => {
const [cooldown, setCooldown] = useState(60); // 60 seconds cooldown
const [resendLoading, setResendLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState<string[]>(Array(6).fill(''));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

useEffect(() => {
  if (cooldown === 0) return;
  const timer = setInterval(() => {
    setCooldown(prev => {
      if (prev <= 1) {
        clearInterval(timer);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);
  return () => clearInterval(timer);
}, [cooldown]);


const handleResendOTP = async () => {
  try {
    setResendLoading(true);
    await api.forgotPassword({ type: "sms", phone });
    toast.success("OTP resent successfully");
    setCooldown(300); // reset cooldown
  } catch (error) {
    toast.error("Failed to resend OTP. Please try again.");
  } finally {
    setResendLoading(false);
  }
};


  useEffect(() => {
    // Initialize refs array
    inputRefs.current = inputRefs.current.slice(0, 6);
  }, []);

  const handleInputChange = (index: number, value: string) => {
    if (value.length > 1) {
      value = value.slice(0, 1);
    }

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // Move to next input if value is entered
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      // Move to previous input on backspace if current input is empty
      inputRefs.current[index - 1]?.focus();
    }
  };

 const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
  e.preventDefault();
  setIsLoading(true);

  try {
    const verificationCode = code.join('');
    console.log("Verification Code:", verificationCode);

    const data = await api.forgotPasswordByPhone({
      otp: verificationCode,
      phone,
    });

    if (data.success) {
      toast.success("Code verified successfully");
      onVerificationSuccess(verificationCode);
    } else {
      // In case API returns success: false
      toast.error(data.message || "Verification failed. Please try again.");
    }

  } catch (error) {
    // Check if it's an Axios error with a response message
    if (error.response && error.response.data && error.response.data.message) {
      toast.error(`Error: ${error.response.data.message}`);
    } else if (error.message) {
      toast.error(`Error: ${error.message}`);
    } else {
      toast.error("An unexpected error occurred during verification.");
    }
  } finally {
    setIsLoading(false);
  }
};


  return (
    <form onSubmit={handleSubmit} className="default-form">
      <div className="form-group" style={{ textAlign: 'center', marginBottom: '30px' }}>
      
        <h1 className="text-white" style={{ 
          fontSize: '20px'
        }}>Enter OTP</h1>
        <p className="mt-3 text-white">We have sent a OTP code on <br /> {phone}</p>
      </div>
      <div className="form-group">
        {/* <label className="text-white">Código de Verificación</label> */}
        <div style={{ 
          display: 'flex', 
          gap: '10px', 
          justifyContent: 'center',
          marginBottom: '20px'
        }}>
          {Array(6).fill(0).map((_, index) => (
            <input
              key={index}
              ref={el => inputRefs.current[index] = el}
              type="text"
              maxLength={1}
              value={code[index]}
              onChange={(e) => handleInputChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              className="form-control"
              style={{ 
                width: '50px',
                height: '50px',
                textAlign: 'center',
                fontSize: '20px',
                borderRadius: 0,
                padding: '0'
              }}
            />
          ))}
        </div>
        {/* <p className="text-white text-center" style={{ fontSize: '14px' }}>
          Se ha enviado un código de 6 dígitos a {phone}
        </p> */}
      </div>
      <div className="form-group">
        <button
          className="theme-btn btn-style-one w-100"
          type="submit"
          disabled={isLoading || code.some(digit => !digit)}
          style={{ 
            backgroundColor: "#1967d2", 
            border: "none",
            height: '50px',
            fontSize: '16px'
          }}
        >
          {isLoading ? (
            <div
              className="spinner-border spinner-border-sm"
              role="status"
            ></div>
          ) : (
            "Enviar"
          )}
        </button>
      </div>
      <div className="text-center text-white mt-3">
  <p className="text-white">¿No ha recibido el código?</p>
  <button
    type="button"
    onClick={handleResendOTP}
    disabled={cooldown > 0 || resendLoading}
    className="btn btn-link text-decoration-underline"
    style={{
      color: "#fff",
      fontSize: "16px",
      textDecoration: "underline",
      padding: 0,
      opacity: cooldown > 0 ? 0.5 : 1,
      cursor: cooldown > 0 ? "not-allowed" : "pointer"
    }}
  >
    {cooldown > 0
      ? `Vuelva a intentarlo en ${Math.floor(cooldown / 60)}:${String(cooldown % 60).padStart(2, "0")}`
      : resendLoading
        ? "Reenviando..."
        : "Inténtalo de nuevo"}
  </button>
</div>
    </form>
  );
}; 